module.exports = __webpack_public_path__ + "static/media/item8.2511e0af.jpg";